/**
 * The staff number HR assigns to a person ("Staff no." / "الرقم الوظيفي" / "Matricule").
 *
 * The server renamed the field from `employeeId` to `staffNumber` on 2026-10-28 and keeps emitting
 * `employeeId` on UserView as an alias for one release. Reading both keeps a page right against a
 * server from either side of the deploy. Pass a user object only: elsewhere `employeeId` is often
 * a user id, and this would show that GUID as a staff number.
 */
export function staffNumberOf(
  u?: { staffNumber?: string | null; employeeId?: string | null } | null,
): string | undefined {
  return (u?.staffNumber ?? u?.employeeId) || undefined;
}
